import React from 'react';
import { Box, Chip, LinearProgress } from '@mui/material';

const SendQueueStatus = ({ queueLength, isProcessing, sendProgress }) => {
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Chip size="small" variant="outlined" label={`Queue: ${queueLength}`} />
        {isProcessing && <Chip size="small" color="primary" label="Processing..." />}
      </Box>

      {sendProgress.isActive && (
        <Box
          sx={{
            position: 'sticky',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1,
            backgroundColor: 'background.paper',
            borderTop: '1px solid',
            borderColor: 'divider',
          }}
        >
          <LinearProgress
            variant="determinate"
            value={sendProgress.progress}
            sx={{
              height: 3,
              '& .MuiLinearProgress-bar': {
                transition: 'transform 0.3s linear',
              },
            }}
          />
        </Box>
      )}
    </>
  );
};

export default SendQueueStatus;
